export interface IMicrositeRecipientSurveyRequest {
    micrositeRecipientId: number,
    isOnDialysis: boolean | null,
    dialysisType: number | null,
    dialysisStartDate: string | null,   // MM/YYYY
    egfr: number | null,
    communityOrgReligious: boolean,
    communityOrgYmca: boolean,
    communityOrgPta: boolean,
    communityOrgOther: boolean,
    communityOrgOtherDetails: string,
    socialFacebook: boolean,
    socialInstagram: boolean,
    socialTikTok: boolean,
    socialLinkedIn: boolean,
    socialNone: boolean,
    socialOther: boolean,
    socialOtherDetails: string,
    commPhoneCall: boolean,
    commText: boolean,
    commEmail: boolean,
    commNoPreference: boolean,
    employmentStatus: number | null,
    isMilitaryVeteran: boolean | null,
    branchOfService: number | null,
    preferredContactTime: number | null
}